var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"invoice-footer-btn"},[_c('button',{staticClass:"btn btn-outline-secondary py-1 no-print",on:{"click":function($event){return _vm.print()}}},[_c('i',{staticClass:"feather icon-printer mr-2"}),_vm._v(" "+_vm._s(_vm.$t("table.print"))+" ")])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }